import { Button, toast } from "@devhop/ui";
import { useNavigate, useSearch } from "@tanstack/react-router";
import { PlusIcon } from "lucide-react";
import { Header } from "@/app/layout/Header";
import { Main } from "@/app/layout/Main";
import { useActionPermission } from "@/modules/auth/presentation/model/useActionPermission";
import type { OffsetPageQueryDTO } from "@/shared/contracts/base";
import { Breadcrumb } from "@/shared/ui/Breadcrumb";
import type { InstallmentPlanTemplateDTO } from "../../domain/contracts";
import {
  useDeleteOutsourceApInstallmentPlanTemplate,
  useOutsourceApInstallmentPlanTemplatesQuery,
} from "../api/queries";
import { InstallmentPlanTemplateTable } from "../ui/InstallmentPlanTemplateTable";

export function OutsourceApInstallmentPlanTemplatesPage() {
  const nav = useNavigate({
    from: "/app/performance/settings/outsource-ap-installment-plans",
  });
  const search: OffsetPageQueryDTO = useSearch({
    from: "/app/performance/settings/outsource-ap-installment-plans",
  });
  const list = useOutsourceApInstallmentPlanTemplatesQuery({
    offset: search.offset,
    limit: search.limit,
    sort: search.sort,
    filters: search.filters,
  });
  const canCreate = useActionPermission(["performance-payouts:create"]);
  const deleteTemplate = useDeleteOutsourceApInstallmentPlanTemplate();

  return (
    <>
      <Header>
        <Breadcrumb
          items={[
            { label: "ແຜງຄວບຄຸມ", to: "/app/dashboard" },
            { label: "Outsource", to: "/app/performance/outsources" },
            { label: "ແມ່ແບບງວດ AP" },
          ]}
        />
      </Header>

      <Main>
        <div className="mb-6 flex items-center justify-between">
          <div>
            <h2 className="font-bold text-2xl tracking-tight">
              ແມ່ແບບງວດເບິກ Outsource (AP)
            </h2>
            <p className="text-muted-foreground">
              ແຍກຈາກແຜນງວດ AR — ໃຊ້ຕອນຕັ້ງແຜນຈ່າຍ KOL/Media ໃນ Event
            </p>
          </div>
          {canCreate ? (
            <Button
              onClick={() =>
                nav({
                  to: "/app/performance/settings/outsource-ap-installment-plans/create",
                })
              }
            >
              <PlusIcon className="size-4" /> ເພີ່ມແມ່ແບບ
            </Button>
          ) : null}
        </div>

        <InstallmentPlanTemplateTable
          data={(list.data?.data ?? []) as InstallmentPlanTemplateDTO[]}
          isLoading={list.isLoading}
          offset={search.offset ?? 0}
          limit={search.limit ?? 20}
          totalCount={list.data?.meta?.total ?? 0}
          onPaginationChange={(offset, limit) =>
            nav({ search: { ...search, offset, limit } })
          }
          onEdit={(row) =>
            nav({
              to: "/app/performance/settings/outsource-ap-installment-plans/$id/edit",
              params: { id: row.id },
            })
          }
          onDelete={async (id) => {
            await deleteTemplate.mutateAsync(id);
            toast.success("ລຶບແມ່ແບບສຳເລັດ");
          }}
        />
      </Main>
    </>
  );
}
